import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Divider,
  Header,
  Label,
  Grid,
  Icon,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { TRANSLATION_FILES } from '../constants/translation';

class BookingSteppers extends Component {
  static propTypes = {
    step: PropTypes.number,
    totalSteps: PropTypes.number,
    lastStepLabel: PropTypes.string,
  }
  static defaultProps= {
    step: 1,
    totalSteps: 3,
  }

  render() {
    const { step, totalSteps, lastStepLabel, t } = this.props;

    return (
      <div>
        {
          totalSteps === 3 ? (
            <Grid className="booking-steppers" centered>
              <Grid.Row columns={5}>
                <Grid.Column className="booking-steppers-left">
                  {
                    step === 1 ? (
                      <Label className="active" circular>
                        1
                      </Label>
                    ) : (
                      <Label color="blue" className="checkmark" circular>
                        <Icon name="checkmark" />
                      </Label>
                    )
                  }
                </Grid.Column>
                <Grid.Column className={`booking-steppers-divider-col ${step > 1 ? 'active' : ''}`}>
                  <Divider className={`${step >= 2 ? 'complete' : ''}`} />
                </Grid.Column>
                <Grid.Column className="booking-steppers-middle">
                  {
                    step <= 2 ? (
                      <Label className={`${step === 2 ? 'active' : ''}`} circular>
                        2
                      </Label>
                    ) : (
                      <Label color="blue" className="checkmark" circular>
                        <Icon name="checkmark" />
                      </Label>
                    )
                  }
                </Grid.Column>
                <Grid.Column className={`booking-steppers-divider-col ${step > 2 ? 'active' : ''}`}>
                  <Divider className={`${step >= 3 ? 'complete' : ''}`} />
                </Grid.Column>
                <Grid.Column className="booking-steppers-right">
                  <Label className={`${step === 3 ? 'active' : ''}`} circular>
                    3
                  </Label>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row className="label-row" textAlign="center">
                <Grid.Column only="tablet computer" tablet={2} computer={2} />
                <Grid.Column mobile={6} tablet={5} computer={5}>
                  <Header as="h4" content={t('Basic details')} />
                </Grid.Column>
                <Grid.Column mobile={4} tablet={2} computer={2}>
                  <Header as="h4" content={t('Payment')} />
                </Grid.Column>
                <Grid.Column mobile={6} tablet={5} computer={5}>
                  <Header as="h4" content={t('Mortgage')} />
                </Grid.Column>
                <Grid.Column only="tablet computer" tablet={2} computer={2} />
              </Grid.Row>
            </Grid>
          ) : ''
        }
        {
          totalSteps === 2 ? (
            <Grid className="booking-steppers" centered>
              <Grid.Row columns={5}>
                <Grid.Column />
                <Grid.Column className="booking-steppers-left">
                  {
                    step === 1 ? (
                      <Label className="active" circular>
                        1
                      </Label>
                    ) : (
                      <Label color="blue" className="checkmark" circular>
                        <Icon name="checkmark" />
                      </Label>
                    )
                  }
                </Grid.Column>
                <Grid.Column className={`booking-steppers-divider-col ${step > 1 ? 'active' : ''}`}>
                  <Divider className={`${step >= 2 ? 'complete' : ''}`} />
                </Grid.Column>
                <Grid.Column className="booking-steppers-right">
                  <Label className={`${step === 2 ? 'active' : ''}`} circular>
                    2
                  </Label>
                </Grid.Column>
                <Grid.Column />
              </Grid.Row>
              <Grid.Row className="label-row">
                <Grid.Column width={7} textAlign="right">
                  <Header as="h4" content={t('Basic details')} />
                </Grid.Column>
                <Grid.Column width={2} />
                <Grid.Column width={7} textAlign="left">
                  <Header as="h4" content={`${lastStepLabel && lastStepLabel !== '' ? lastStepLabel : t('Mortgage')}`} />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          ) : ''
        }
      </div>
    );
  }
}

export default withTranslation(TRANSLATION_FILES.screens)(BookingSteppers);



// WEBPACK FOOTER //
// ./src/components/BookingSteppers.jsx